export default {
  page: {
    title: {
      base: 'Mokėjimo šliuzas Autopay',
      start: 'Mokėjimo būdo pasirinkimas',
      result: 'Pasikartojantis BLIK mokėjimas',
      visadata: 'VisaMobile',
      continue: 'Tęsti – mokėjimo būdo pasirinkimas',
      wait: 'Palauk',
      confirmation: 'Mokėjimo patvirtinimas',
      thankYou: 'Ačiū už mokėjimą',
      error: 'Svetainės klaida',
      errorNotFound: 'Puslapis nerastas',
      secureBack: 'Krautuvas',
      maintenance: 'Priežiūra',
      regulationsApproval: 'Taisyklės ir privatumo politika',
      toTransferData: 'perdavimo detales',
      sessionTimeout: 'Puslapis po sesijos pabaigos',
      paywayError: 'Mokėjimo kanalas nepasiekiamas'
    }
  },
  header: {
    availabilityAdjust: {
      increaseFontSize: 'Padidinti šrifto dydį',
      decreaseFontSize: 'Sumažinti šrifto dydį',
      changeContrast: 'Keisti kontrastą',
      changeLanguage: 'Keisti svetainės kalbą',
      skipToContent: 'Pereiti prie turinio',
      skipToContentLabel: 'Pereiti prie pagrindinio turinio',
      logoTitle: 'Mokėjimo šliuzas Autopay',
      langLoading: 'Kraunama kalba',
      langChanged: 'Kalba pakeista'
    },
    sessionTimer: {
      timeOut: 'Sesija pasibaigė',
      sessionEnd: 'Sesijos pabaiga:',
      label: 'Prailginkite seanso laiką',
      button: 'Prailginti'
    }
  },
  footer: {
    text1: 'Turite papildomų klausimų apie mokėjimus internetu ar kitas mūsų paslaugas? <a title="Jis atidaromas naujame lange" href="https://pomoc.autopay.pl/?pk_campaign=paywall&pk_kwd=start&pk_medium=hyperlink" class="footer-text-link" target="_blank" rel="noreferrer">Eiti į pagalbos puslapį</a>',
    text2: {
      part1: 'Asmens duomenų valdytojas yra Autopay',
      part2: '6 Powstańców Warszawy g. 81-718 Sopota. Asmens duomenų teikimas yra savanoriškas, tačiau būtinas norint užpildyti pateiktą paraišką. Teisinis pagrindas, tikslas, asmens duomenų tvarkymo laikotarpis ir Naudotojo teisės bei kita svarbi informacija, susijusi su asmens duomenų tvarkymo principais, yra išsamiai apibrėžta <a href="{privacyPolicyUrl}" class="footer-text-link" target="_blank" title="Eiti į puslapį su privatumo politikos dokumentu (128 KB, PDF)" rel="noreferrer">Autopay S.A. privatumo politika</a>'
    },
    linkShowMoreTitle: 'Rodyti daugiau informacijos',
    linkShowMoreText: 'Skaityti daugiau',
    linkShowLessTitle: 'Rodyti mažiau informacijos',
    linkShowLessText: 'Skaitykite mažiau'
  },
  paywall: {
    header: 'Pasirinkite mokėjimo būdą',
    info: {
      paywayNotAvailable: 'Atsiprašome, bet panašu, kad šiuo metu jūsų įrenginyje jūsų pasirinktas mokėjimo būdas negalimas.',
      applePayNotAvailable: 'Atsiprašome, bet panašu, kad šiuo metu jūsų įrenginyje negalima mokėti naudojant Apple Pay.',
      googlePayNotAvailable: 'Atsiprašome, bet panašu, kad šiuo metu jūsų įrenginyje negalima mokėti naudojant Google Pay.'
    },
    paywayGroup: {
      inactiveMessage: 'Mokėjimas šiuo metu negalimas',
      notice: {
        novelty: 'NAUJIENA',
        promotion: 'AKCIJA',
        recommended: 'REKOMENDUOJAMA',
        mastercard: 'GREITAI IR SAUGU',
        mastercardC2P: 'GREITAI IR SAUGU',
        blik: 'BLIKOMANIA – registruokis ir laimėk deimantus!',
        visaMobile: 'Mokėkite sklandžiai ir saugiai'
      },
      bank: {
        many: 'bankai',
        one: 'bankas',
        two: 'bankai'
      },
      wallet: {
        many: 'piniginės',
        one: 'piniginė',
        two: 'piniginės'
      },
      otp: {
        many: 'būdais',
        one: 'būdu',
        two: 'būdais'
      },
      blikPayLater: {
        text1: 'Pirkite dabar, sumokėkite per 30 dienų – be papildomų mokesčių. Įvedę BLIK kodą galite gauti iki 4000 PLN apsipirkimo limitą.',
        text2: 'Paslauga teikiama adresu:'
      },
      blikAuto: {
        bankList: 'Paslauga teikiama:',
        infoModel0: 'Vėlesni mokėjimai bus automatiškai nurašyti iš jūsų sąskaitos.',
        infoModelM: 'Vėlesniems mokėjimams reikės tik patvirtinimo banko paraiškoje.'
      }
    },
    paywayList: {
      label: 'Mokėjimo tipų grupė',
      linkSelectOther: 'Pasirinkite kitą'
    },
    paywaySingle: {
      accountAtAnotherBank: 'Turiu sąskaitą kitame banke'
    },
    paywaySwitch: {
      methodShortSingle: 'Vienkartiniai',
      methodLongSingle: 'Vienkartiniai mokėjimai',
      methodShortAuto: 'Pasikartojantis',
      methodLongAuto: 'Periodiniai mokėjimai'
    },
    form: {
      payway: {
        label: 'Pasirinkite mokėjimo būdą'
      },
      card: {
        label: 'Įveskite kortelės duomenis',
        flowLabel: 'Mokėjimo kortelė',
        iframe: {
          title: 'Reikia užpildyti kredito kortelės duomenų formą'
        }
      },
      visaMobile: {
        flowLabel: 'Telefono numeris',
        iframe: {
          title: 'Forma su telefono numeriu turi būti užpildyta'
        },
        status: {
          pending: {
            statusText: 'Laukiama patvirtinimo',
            header: 'Patvirtinkite mokėjimą programėlėje',
            descriptionText1: 'Mokėjimą galite patvirtinti Visa Mobile programėlėje arba banko programėlėje su aktyvuota Visa Mobile.',
            descriptionText2: 'Programėlėje patvirtinę operaciją, laukite mokėjimo rezultato',
            descriptionText3: 'Vykdomas operacijos atšaukimas',
            cancelButton: 'Atšaukti mokėjimą'
          },
          success: {
            statusText: 'Dėkojame, kad įsigijote!',
            descriptionText: 'Mokėjimas sėkmingai atliktas'
          },
          error: {
            statusText: 'Įsitikinkite, kad mokėjimo kortelėje, naudojamoje Visa Mobile mokėjimui, turite pakankamai lėšų.',
            descriptionText: 'Mokėjimas atmestas'
          }
        },
        apps: 'Programos, palaikančios Visa Mobile mokėjimus',
        help: 'Ar tau reikia pagalbos?',
        info: 'Sužinokite daugiau',
        secure: 'Saugus mokėjimas su SSL šifravimu',
        modal2: {
          header: 'Norėdami patvirtinti mokėjimą, atidarykite Visa Mobile programėlę arba banko, kuriame suaktyvinote Visa Mobile, programėlę',
          listText1: 'savo banko mobiliojoje programėlėje esate įdiegę Visa Mobile arba Visa Mobile.',
          listText2: 'Visa Mobile arba banko programėlėje, kurioje įjungta Visa Mobile, įjungti pranešimai',
          listText3: 'jūsų pateiktas numeris yra teisingas: <strong class="no-wrap">+{prefix} {phone}</strong>',
          listText4: 'Taip pat įsitikinkite, kad...'
        }
      },
      click2pay: {
        loaderText: 'Ieškome jūsų el. pašto adreso<br> skiltyje <strong>Spustelėkite, kad sumokėtumėte</strong>',
        saveCard: {
          text1: 'Išsaugokite savo kortelę',
          text2mc: 'Jūsų duomenys bus saugiai išsaugoti <strong>Mastercard Click to Pay</strong>',
          text2visa: 'Jūsų duomenys bus saugiai išsaugoti <strong>Visa Click to Pay</strong>',
          link: 'Sužinokite daugiau'
        },
        email: {
          labelForClick2Pay: 'Pašto adresas mokėjimo pranešimams'
        },
        cardSelect: {
          selected: 'Pasirinkta',
          select: 'Pasirinkite',
          payOther: 'Įveskite savo kortelės duomenis',
          back: 'Atgal'
        },
        cardSelected: {
          header: 'Naudokite kortelę, išsaugotą spustelėjus mokėti',
          date: 'galioja iki',
          buttonChange: 'Keisti'
        },
        codeForm: {
          description: 'Mes radome jūsų el. pašto adresą spustelėdami mokėti.',
          codeSentEmail: 'Įveskite vienkartinį kodą, kurį išsiuntėme adresu {email}, kad prisijungtumėte prie paskyros.',
          codeSentPhone: 'Įveskite vienkartinį SMS kodą, kurį išsiuntėme numeriu {phone}, kad prisijungtumėte prie paskyros.',
          codeSent: 'Įveskite vienkartinį kodą, kurį išsiuntėme {validationChannel}, kad prisijungtumėte prie paskyros.',
          codeLabel: 'Įveskite kodą',
          codePlaceholder: 'įveskite kodą',
          codeLabelFlow: 'Kodas',
          codeSendLabel: 'Siųsti naują kodą',
          codeSendAriaLabel: 'per',
          codeSendAriaLabel2: 'arba',
          buttonSendNewSms: 'SMS',
          buttonSendNewEmail: 'e-mail',
          trustedLabel: 'Pridėkite šį įrenginį prie patikimų sąrašo<br> <span>Kitą kartą atpažinsime šį įrenginį ir mokėsite neprisijungę</span>',
          buttonSubmit: 'Kitas',
          buttonChangeCard: 'Įveskite savo kortelės duomenis'
        },
        info: {
          description: 'Mokėjimas kortele yra užšifruotas ir saugus. Operacija bus autorizuota naudojant 3DSecure banko svetainėje.'
        },
        loginForm: {
          emailLabel: 'Įveskite savo el. pašto adresą, kad prisijungtumėte prie Spustelėkite ir mokėkite.',
          emailPlaceholder: 'pašto adresą',
          emailLabelFlow: 'El. pašto adresas',
          buttonSubmit: 'Prisijunkite',
          buttonBack: 'Atgal'
        },
        newUserForm: {
          header: 'Išsaugokite kortelę spustelėdami mokėti',
          description: 'Mums reikia daugiau informacijos, kad išsaugotume jūsų kortelę.',
          emailLabel: 'Įveskite el. pašto adresą',
          emailPlaceholder: 'el. pašto adresą',
          emailLabelFlow: 'El. pašto adresas',
          countryLabel: 'Šalis',
          firstnameLabel: 'Vardas',
          firstnamePlaceholder: 'pavadinimas',
          firstnameLabelFlow: 'Vardas',
          lastnameLabel: 'Pavardė',
          lastnamePlaceholder: 'pavardė',
          lastnameLabelFlow: 'Pavardė',
          phoneLabel: 'Telefono numeris',
          phonePlaceholder: 'telefono numeris',
          phoneLabelFlow: 'Telefonas',
          countryCodePlaceholder: 'kodas',
          countryCodeLabelFlow: 'Kodas',
          trustedLabel: 'Pridėkite šį įrenginį prie patikimų sąrašo<br><span>Kitą kartą atpažinsime šį įrenginį ir mokėsite neprisijungę</span>',
          termsMastercardLabel: 'Tęsdami sutinkate su <a href="https://www.mastercard.com/global/click-to-pay/country-listing/terms.html" target="_blank">naudojimo sąlygomis</a> ir suprantate, kad jūsų duomenys bus tvarkomi pagal <a href="https://www.mastercard.com/global/click-to-pay/country.html-listing/privacy/privacy.html-"ylisting Mastercard.',
          termsVisaLabel: 'Tęsdami sutinkate su <a href="{c2pVisaTermsUrl}" target="_blank">Visa Solution paslaugų teikimo sąlygomis</a> ir suprantate, kad jūsų duomenys bus tvarkomi pagal <a href="{c2pVisaPrivacyUrl}" target="_blank">Visa privatumo politiką</a>.',
          cookieVisaLabel: 'Tęsdami sutinkate su <a href="{c2pVisaCookieUrl}" target="_blank">Visa slapukų politika</a>.',
          c2pInfo: 'Jūsų el. pašto arba mobiliojo telefono numeris bus naudojamas jus patvirtinti. Gali būti taikomi pranešimų / duomenų įkainiai.',
          buttonSubmit: 'Sutaupykite ir mokėkite',
          buttonBack: 'Mokėkite neišsaugodami kortelės'
        },
        profile: {
          header: 'Prisijunkite prie Spustelėkite ir mokėkite.',
          buttonChangeEmail: 'Keisti el. pašto adresą'
        },
        modal: {
          title: 'Spustelėkite norėdami sumokėti – informacija',
          header: 'Mokėkite greitai ir saugiai, iš naujo neįvesdami kortelės informacijos pagal naująjį Spustelėkite ir mokėkite standartą',
          text1: 'Mokėdami kortele ieškokite logotipo <img src="/web/img/click2pay/Click_to_Pay.svg" style="height: 14px" alt="Click to Pay Logo"> ir greitai bei patogiai mokėkite kortele.',
          text2: 'Click To Pay yra naujas mokėjimo kortele standartas, kurį palaiko Visa ir Mastercard.',
          text3: 'Galite naudoti kortelę Spustelėkite ir mokėkite paskyroje, norėdami mokėti parduotuvėse Lenkijoje ir užsienyje, iš naujo neįvesdami kortelės duomenų.',
          text4: 'Duomenys saugiai saugomi Visa arba Mastercard. Visa informacija yra visiškai užšifruota.',
          text5: 'Būsimų mokėjimų metu Click to Pay atpažins jūsų el. pašto adresą, todėl galėsite akimirksniu atsiskaityti išsaugotomis kortelėmis.',
          text6: 'Visus mokėjimus papildomai patvirtinate savo banke, o tai garantuoja visišką saugumą.',
          processError: 'Apdorojant mokėjimą spustelėjus mokėjimą įvyko klaida. Atlikite standartinį mokėjimą kortele.'
        }
      },
      email: {
        label: 'Pateikite savo el. pašto adresą',
        flowLabel: 'El. pašto adresas',
        tip: 'Mums reikia jūsų el. pašto adreso, kad galėtume atsiųsti jums pranešimus apie jūsų mokėjimo būseną.',
        fuse: 'Įsitikinkite, kad jūsų el. pašto adresas įvestas teisingai.'
      },
      blikCode: {
        label: 'Įveskite BLIK kodą',
        flowLabel: 'CAN kodas'
      },
      terms: {
        header: 'Sutikimai ir pareiškimai',
        selectAll: 'Pasirinkite viską',
        fieldNotRequired: 'Neprivalomas laukas',
        partnerMarketingTextLess: 'Ar norėtumėte iš mūsų gauti įspėjimus el. paštu, SMS ar telefonu apie geriausius mūsų ar mūsų partnerių organizuojamus pasiūlymus, akcijas, konkursus ir kitus įdomius renginius?',
        partnerMarketingTextMore: 'Pažadame nesiųsti šiukšlių! Jei jums pabodo mūsų pranešimai, galite bet kada atšaukti savo sutikimą.',
        tradeMarketingTextLess: 'Ar norėtumėte, kad perduotume jūsų el. pašto adresą arba telefono numerį mūsų patikimiems partneriams, kad jie galėtų suteikti jums įdomios informacijos ir pasiūlymų?',
        tradeMarketingTextMore: 'Užtikriname, kad mūsų partneriai yra geros reputacijos įmonės, kurios, kaip ir mes, nemėgsta šiukšlių siuntimo, ir jūs galite bet kada atšaukti savo sutikimą.'
      },
      termsFlowLabel: 'Taisyklės',
      termsLabelDefault: 'Perskaičiau ir sutinku su <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Atsisiųsti paslaugos teikimo sąlygų failą" rel="noreferrer">mokėjimo paslaugų sąlygomis</a> ir <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Atsisiųsti Autopay S.A. privatumo politikos failą">Privatumo politika</a>. Noriu, kad paslauga būtų atlikta nedelsiant, o sutarties atsisakymo atveju žinau, kad iki sutarties atsisakymo, mano prašymu, negausiu kompensacijos už suteiktas paslaugas patirtų išlaidų.',
      termsReccuring: 'Jei norite atlikti mokėjimą, sutikite su <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Atsisiųsti paslaugos teikimo sąlygų failą" rel="noreferrer">paslaugų teikimo sąlygomis</a> ir <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Atsisiųsti Autopay S.A. privatumo politikos failą">Privatumo politika</a> Autopay S.A., sutikite dėl neatidėliotinų mokėjimo paslaugų ir sutiksite apmokestinti mano mokėjimo kortelę.',
      termsReccuringMore1: 'Sutinku, kad paslauga būtų suteikta nedelsiant ir patvirtinu, kad sutarties atsisakymo atveju man nebus kompensuojamos išlaidos, patirtos už paslaugas, suteiktas mano prašymu iki sutarties atsisakymo.',
      termsReccuringMore2: 'Sutinku, kad Autopay S.A. periodiškai apmokestintų mano mokėjimo kortelę ir atliktų operaciją {receiverName} naudai. Pasikartojančio mokėjimo kortele sąlygos apibrėžtos <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the terms of service file" rel="noreferrer">mokėjimo paslaugų sąlygose</a>. Pareiškiu, kad žinau mano su {receiverName} nustatytus mokesčių iš mano mokėjimo kortelės sumų nustatymo laikotarpius, dažnumą ir taisykles bei šio sutikimo atšaukimo būdus. Jei kils klausimų dėl pasikartojančio mokėjimo iš mokėjimo kortelės, susisieksiu su {receiverName}.',
      mwfClauseLess: 'Jei norite atlikti mokėjimą, sutikite su <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Atsisiųsti failą su paslaugų teikimo sąlygomis" rel="noreferrer">taisyklių ir nuostatų</a> sąlygomis ir su <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Atsisiųsti Autopay S.A. privatumo politikos failą">Autopay S.A. privatumo politika</a>, sutikite pradėti operaciją jūsų banke per Autopay S.A. ir pateikite išsamią šios operacijos informaciją gavėjui bei paprašykite nedelsiant atlikti mokėjimo paslaugą.',
      mwfClauseMore: 'Noriu, kad paslauga būtų suteikta nedelsiant ir žinau, kad sutarties atsisakymo atveju patirtų išlaidų negrąžinsiu.',
      mwfClauseARIA: 'Jei norite atlikti mokėjimą, priimkite Autopay S.A. taisykles ir privatumo politiką, sutikite pradėti operaciją jūsų banke per Autopay S.A. ir pateikite šios operacijos duomenis gavėjui bei paprašykite nedelsiant įvykdyti mokėjimo paslaugą. Noriu, kad paslauga būtų suteikta nedelsiant ir žinau, kad sutarties atsisakymo atveju patirtų išlaidų negrąžinsiu. <a href="{regulationUrl}" class="form-text-link" target="_blank" title="" rel="noreferrer" tabindex="-1">Atsisiųskite failą su paslaugų teikimo sąlygomis</a> <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="" tabindex="-1">Atsisiųskite privatumo politikos failą</a>',
      paymentInfo: 'Mokėjimo pavedimas jūsų bankui pateikiamas per Sopote įsikūrusią „Autopay S.A.“ ir bus apdorotas pagal jūsų banko nustatytas sąlygas. Pasirinkę banką, autorizuosite mokėjimą.',
      changePaywayLink1: 'Dar gali',
      changePaywayLink2: 'pakeisti mokėjimo formą',
      linkMore: 'DAUGIAU',
      linkShowMoreTitle: 'Rodyti papildomą informaciją',
      linkLess: 'MAŽIAU',
      linkShowLessTitle: 'Slėpti papildomą informaciją',
      submitButton: {
        visaMobile: 'Mokėti iki',
        fastTransfer: 'Sugeneruokite pervedimo informaciją',
        mwf: 'Priimu ir moku',
        pis: 'Priimu ir pradedu mokėti',
        auto: 'Užsakyti periodinį mokėjimą',
        autoPayment: 'Užsakymo apmokėjimas',
        other: 'Mokėkite dabar',
        orange: 'Patvirtinti',
        c2pNext: 'Kitas',
        c2pAccept: 'Priimu',
        c2pSaveAndPay: 'Sutaupykite ir mokėkite',
        ariaLabelInactive: 'Norėdami tęsti, teisingai užpildykite privalomus laukus'
      }
    },
    frData: {
      pageTitle: 'Išsamūs pervedimo duomenys',
      header: 'Užsisakykite pervedimą naudodami pateiktą informaciją',
      nrbLabel: 'Gavėjo paskyra',
      nameLabel: 'Gavėjo vardas',
      addressLabel: 'Gavėjo adresas',
      titleLabel: 'Perdavimo pavadinimas',
      amountLabel: 'Pervedimo suma',
      timeLabel: 'Atlikti sandorį iki',
      linkCopy: 'Kopijuoti',
      linkGetPdf: 'Atsisiųsti pdf su duomenimis',
      linkGetPdfTitle: 'Atsidaro naujame lange',
      linkGoToBank: 'Prisijunkite prie banko',
      info: 'Prisijunkite prie savo banko sąskaitos. Nukopijuokite duomenis į perkėlimą. Svarbu, kad duomenys būtų vienodi, nekeistų sumos, valiutos ar pavadinimo ir pan.',
      verifyInfo: 'Jūsų banko patvirtinimas gali užtrukti iki 3 dienų, nes negalėsite apdoroti greito pervedimo. Galite tęsti arba galite patvirtinti savo banko sąskaitą kitu būdu. Jei norite pasirinkti kitą metodą, spustelėkite <strong>{backToShopText}</strong> ir grįžkite į Fortuna svetainę.'
    },
    frInfo: {
      paywall: {
        text1: 'Šis mokėjimo būdas nepalaiko tarptautinių pervedimų.',
        text2: 'Pervedimai iš užsienio bankų nebus vykdomi.'
      },
      frData: {
        text1: 'Pastaba: Nekeiskite pervedimo pavadinimo ar sumos.',
        text2: 'Pakeitus šiuos duomenis, mokėjimas gali būti neteisingai užregistruotas.'
      }
    },
    processing: {
      pageTitle: 'Laukiama operacijos apdorojimo puslapis',
      loaderAnimation: 'Animacija rodoma laukimo metu',
      header: 'Ruošiame jūsų mokėjimo puslapį.',
      description: 'Palaukite šiek tiek...',
      info: {
        header: 'Pastaba!',
        description: 'Neuždarykite puslapio po operacijos – kitaip jūsų pinigai nebus išsiųsti gavėjui.'
      },
      loaderText: 'Vykdomas duomenų perdavimas.<br>Tai užtruks daugiausia 30 sekundžių.'
    }
  },
  thankYou: {
    pageTitle: 'Informacija apie sandorio rezultatą',
    form: {
      emailLabel: 'paštas',
      buttonSubmit: 'Grįžti į partnerio puslapį'
    },
    negative: {
      header: 'Mokėjimas nebuvo apdorotas, nes trūko operacijos leidimo.',
      description: 'Jei vis tiek norite pasinaudoti konkretaus pardavėjo ar paslaugų teikėjo pasiūlymu – grįžkite į jų svetainę, pasirinkite prekę ar paslaugą ir apmokėkite pasirinktu būdu.'
    },
    pending: {
      header: 'Dėkojame, kad užsakėte mokėjimą per mokėjimo šliuzą',
      description: 'Vykdomas operacijos būsenos tikrinimas. Kai procesas bus baigtas, el. pašto dėžutėje gausite informaciją apie mokėjimo būseną.'
    },
    positive: {
      header: 'Dėkojame, jūsų mokėjimas buvo apdorotas.',
      description: 'Patvirtinimą atsiųsime Jūsų nurodytu el. pašto adresu.'
    }
  },
  regulationsApproval: {
    header: 'Priimti sandorį'
  },
  wait: {
    pageTitle: 'Laukiamas puslapis'
  },
  sessionTimeout: {
    pageTitle: 'Puslapis po sesijos pabaigos',
    header: 'Mokėjimo užbaigimo laikas praėjo',
    description: 'Galite bet kada grįžti į partnerio svetainę, užsisakyti iš naujo arba naudotis paslauga ir atlikti mokėjimą pasirinktu būdu.'
  },
  paywayError: {
    pageTitle: 'Pasirinktas mokėjimo kanalas nepasiekiamas',
    header: 'Deja, pasirinktas mokėjimo būdas šiuo metu nepasiekiamas.',
    description: 'Grįžkite į partnerio puslapį ir bandykite dar kartą vėliau.'
  },
  loader: {
    loading: 'Kraunama',
    defaultAnimation: 'Puslapiui įkeliant rodoma animacija',
    slider: 'Slankiklis su besikeičiančiais tekstais',
    text1: 'Autopay siekia pasiekti anglies neutralumo. Taip ir jūs, naudodamiesi mūsų paslaugomis.',
    text2: 'Autopay į darbą važiuojame dviračiais, kad sumažintume šiltnamio efektą sukeliančių dujų išmetimą į atmosferą. Taip ir jūs, naudodamiesi mūsų paslaugomis.',
    text3: 'Autopay dirba ekologiška energija. Taip pat ir jūs, kai naudojatės mūsų paslaugomis.',
    text4: 'Autopay sumažiname popieriaus suvartojimą. Taip pat elkitės ir jūs, kai naudojatės mūsų paslaugomis.',
    rateLimitExceeded: 'Padidėja operacijų srautas, todėl mokėjimo apdorojimas gali užtrukti ilgiau nei įprastai. Palaukite ir neatnaujinkite mokėjimo puslapio.'
  },
  result: {
    pending: {
      header: 'Patvirtinkite pasikartojantį BLIK mokėjimą',
      description: 'Atidarykite banko programą ir patvirtinkite mokėjimą'
    },
    positive: {
      initWithPayment: {
        header: 'Mokama',
        description: 'Pervedėme jūsų lėšas gavėjui. Galutinį BLIK periodinio mokėjimo aktyvinimo patvirtinimą gausite iš prekybininko ar paslaugų teikėjo.',
        button: 'Grįžti į svetainę'
      },
      initWithRefund: {
        header: 'Atlikta',
        description1: 'Gavome jūsų užsakymą ir persiuntėme jį apdoroti. Galutinį patvirtinimą gausite tiesiai iš parduotuvės.',
        description2: 'Suma {amount} {currency} bus grąžinta į jūsų banko sąskaitą.',
        button: 'Grįžti į svetainę'
      },
      initWithoutPayment: {
        header: 'Atlikta',
        description: 'Įgaliname pasikartojančius BLIK mokėjimus. Netrukus gausite informaciją iš {shopName}.',
        button: 'Grįžti į svetainę'
      }
    },
    negative: {
      recurrencyNotSupported: {
        header: 'Nepavyko įjungti BLIK pasikartojančio mokėjimo',
        description1: 'Negalite įjungti BLIK pasikartojančių mokėjimų. Šis metodas šiuo metu nepasiekiamas jūsų banko naudotojams.',
        description2: 'Bandykite dar kartą naudodami BLIK kodą su palaikomais bankais arba pasirinkite kitą mokėjimo metodą.',
        buttonContinue: 'Keisti mokėjimo būdą',
        buttonReturn: 'Grįžti į svetainę'
      },
      wrongTicket: {
        header: 'Neteisingas BLIK kodas',
        description: 'Įvestas BLIK kodas neteisingas arba pasibaigęs. Patikrinkite kodą ir bandykite dar kartą. Jei problema išlieka, sugeneruokite naują kodą banko programoje.',
        buttonContinue: 'Keisti mokėjimo būdą',
        buttonReturn: 'Grįžti į svetainę'
      },
      generic: {
        header: 'Nepavyko įjungti BLIK pasikartojančio mokėjimo',
        description: 'Negalite įjungti BLIK pasikartojančių mokėjimų. Bandykite dar kartą naudodami BLIK kodą su palaikomais bankais arba pasirinkite kitą mokėjimo metodą.',
        buttonContinue: 'Keisti mokėjimo būdą',
        buttonReturn: 'Grįžti į svetainę'
      }
    }
  },
  orderDetails: {
    header: 'Detalės',
    headerAriaLabel: 'Sandorio informacija',
    amountLabel: 'Mokėtina suma',
    receiverLabel: 'Gavėjas',
    orderLabel: 'Užsakymo numeris',
    amountOriginalCurrencyLabel: 'Pradinė suma',
    currencyRateLabel: 'Valiutos kursas',
    feeLabel: 'Sandorio tvarkymo mokestis',
    feeLabelDcc: 'Valiutos konvertavimo mokestis',
    customerNumberLabel: 'Kliento numeris',
    invoiceNumberLabel: 'Sąskaitos numeris',
    accountNumberLabel: 'Sąskaitos numeris',
    paywayLabel: 'Mokėjimo būdas',
    paywayName: 'Banko pavedimas internetu',
    linkBack: 'Atgal į parduotuvę',
    linkBackTitle: 'Palikite sandorį ir grįžkite į parduotuvę',
    linkMore: 'parodyk daugiau',
    linkLess: 'rodyti mažiau',
    toggleBtnUnfoldAriaLabel: 'Išplėskite užsakymo informaciją',
    toggleBtnFoldAriaLabel: 'Sutraukti išsamią užsakymo informaciją',
    blikReccuringNameLabel: 'Vardas',
    blikReccuringValidToLabel: 'Galiojimo laikas',
    blikReccuringValidToText: 'Neribotam laikui',
    blikReccuringFrequencyLabel: 'Dažnis',
    blikReccuringFrequencyText: 'Kiekvieną kartą, kai naudojatės paslauga'
  },
  error: {
    pageTitle: 'Klaidos puslapis',
    linkBackUrlSet: 'Grįžti į partnerio svetainę',
    linkBackUrlNotSet: 'Eikite į pagalbos puslapį',
    sessionTimeout: {
      title: 'Mokėjimo užbaigimo laikas praėjo',
      message: 'Galite bet kada grįžti į partnerio svetainę, užsisakyti iš naujo arba naudotis paslauga ir atlikti mokėjimą pasirinktu būdu.'
    },
    notFoundError: {
      pageTitle: 'Klaidos puslapis 404 – puslapis nerastas',
      title: 'Panašu, kad nuplaukėte per toli ir nepavyko rasti puslapio, kurį norite aplankyti.',
      message: 'Galimos priežastys: puslapis neegzistuoja arba buvo pašalintas, vykdoma priežiūra, neteisingas puslapio adresas, įvyko techninė klaida.'
    },
    generalError: {
      title: 'Atsiprašau',
      message: 'Šiuo metu negalime apdoroti jūsų pervedimo.'
    },
    errFieldNotFound: {
      title: 'Atsiprašau',
      message: ''
    },
    errBadClientSource: {
      title: 'Atsiprašau',
      message: ''
    },
    nrParametersError: {
      title: 'Atsiprašau',
      message: 'Šiuo metu negalime apdoroti jūsų pervedimo.'
    },
    transactionOutdated: {
      title: 'Laikas atlikti mokėjimą praėjo.',
      message: 'Užsisakykite dar kartą.'
    },
    linkValidityTimeOutdated: {
      title: 'Laikas atlikti mokėjimą praėjo.',
      message: 'Užsisakykite dar kartą.'
    },
    transactionValidityTimeOutdated: {
      title: 'Laikas atlikti mokėjimą praėjo.',
      message: 'Užsisakykite dar kartą.'
    },
    multiplyTransaction: {
      title: 'Atsiprašau',
      message: 'Sandoris jau egzistuoja ir laukia apmokėjimo.'
    },
    transactionCanceled: {
      title: 'Atsiprašau',
      message1: 'Sandoris buvo atšauktas.',
      message2: 'Užsisakykite dar kartą.'
    },
    multiplyPaidTransaction: {
      title: 'Atsiprašau',
      message: 'Už sandorį jau sumokėta.'
    },
    transactionReject: {
      title: 'Atsiprašau',
      message1: 'Oi, kažkas nutiko.',
      message2: 'Vyksta taisymas...'
    },
    bankDisabled: {
      title: 'Atsiprašau',
      message: 'Pasirinktas bankas šiuo metu nepasiekiamas.'
    },
    bankTemporaryMaintenance: {
      title: 'Atsiprašau',
      message: 'Šiuo metu negalime apdoroti jūsų pervedimo.'
    },
    insufficientStartAmount: {
      title: 'Atsiprašau',
      message: 'Viršytas pervedimo sumos limitas.'
    },
    startAmountOutOfRange: {
      title: 'Atsiprašau',
      message: 'Viršytas pervedimo sumos limitas.'
    },
    nonAccountedLimitExceeded: {
      title: 'Atsiprašau',
      message: 'Mokėjimas negali būti atliktas, nes pardavėjas pasiekė mėnesio pardavimo limitą.'
    }
  },
  confirmation: {
    pageTitle: 'Informacija apie mokėjimo procesą',
    linkBack: 'Aš grįšiu į svetainę',
    linkBackTimeout: 'Grįžti į partnerio svetainę',
    linkBackTimeoutTime: 'sekundžių',
    linkBackAutoRedirect: 'Šis puslapis bus automatiškai nukreiptas į partnerio svetainę po {time} sekundžių. Sąveika su puslapiu sustabdys atgalinį skaičiavimą.',
    linkBackTimerStopped: 'Automatinis nukreipimas sustabdytas. Norėdami grįžti į partnerio svetainę, naudokite mygtuką Grįžti į svetainę.',
    incorrectAmount: {
      header: 'Neteisinga suma',
      description: 'Nepervedėme jūsų mokėjimo gavėjui, nes suma buvo neteisinga.',
      description2: 'Spustelėkite mygtuką, norėdami grįžti į puslapį ir pakartoti. Nepamirškite nekeisti jokių duomenų.'
    },
    multiplePaid: {
      header: 'Dvigubas depozitas',
      description: 'Gavėjas jūsų mokėjimą gavo du kartus. Nesijaudinkite – grąžinsite pinigus.',
      description2: 'Susisiekite su gavėju ir pateikite jam mokėjimo patvirtinimą.'
    },
    negative: {
      header: 'Jokio mokėjimo',
      description: 'Apdorojant mokėjimą įvyko klaida. Bet nieko neprarasta.',
      description2: 'Spustelėkite mygtuką, norėdami grįžti į puslapį ir pakartoti.'
    },
    notFound: {
      header: 'Jokio mokėjimo',
      description: 'Apdorojant mokėjimą įvyko klaida. Bet nieko neprarasta.',
      description2: 'Spustelėkite mygtuką, norėdami grįžti į puslapį ir pakartoti.'
    },
    outdated: {
      header: 'Laiko pabaiga',
      description: 'Mes nepervedėme jūsų mokėjimo gavėjui.',
      description2: 'Spustelėkite mygtuką, norėdami grįžti į puslapį ir pakartoti.'
    },
    outdatedPaidNotRefunded: {
      header: 'Laiko pabaiga',
      description: 'Mes nepervedėme jūsų mokėjimo gavėjui. Jei pinigai buvo nuskaityti iš jūsų sąskaitos, nesijaudinkite, lėšas gausite per kelias dienas.',
      description2: 'Spustelėkite mygtuką, norėdami grįžti į puslapį ir pakartoti.'
    },
    outdatedPaidRefunded: {
      header: 'Laiko pabaiga',
      description: 'Mes nepervedėme jūsų mokėjimo gavėjui. Jei pinigai buvo nuskaityti iš jūsų sąskaitos, nesijaudinkite, mes jau grąžinome juos.',
      description2: 'Spustelėkite mygtuką, norėdami grįžti į puslapį ir pakartoti.'
    },
    pending: {
      header: 'Vykdoma',
      description: 'Apdorojame jūsų mokėjimą. Mes jums pranešime, kai jis pasieks gavėją.'
    },
    positive: {
      header: 'Mokama',
      visaVideo: 'Reklaminis vaizdo įrašas paleistas po sėkmingos operacijos',
      description: 'Pervedėme jūsų lėšas gavėjui.',
      dccStatement: 'Man buvo suteikta galimybė pasirinkti valiutas, kurios bus naudojamos mano mokėjimui. Pasirinkau operacijos valiutą ir sutikau mokėti {currency} nurodytu valiutos kursu. Dinaminę valiutos konvertavimo (DCC) paslaugą teikia „Autopay S.A.'
    }
  },
  messages: {
    accessForbidden: 'Nėra prieigos',
    internalServerError: 'Įvyko netikėta klaida. Vėliau bandykite dar kartą.',
    validators: {
      required: 'Privalomas laukas',
      pattern: 'Pateikite galiojančią vertę',
      blikCode: 'Įveskite 6 skaitmenų BLIK kodą',
      emailRequired: 'Nurodykite teisingą el. pašto adresą',
      emailNotValid: 'Nurodykite teisingą el. pašto adresą',
      emailNotRecognized: 'Nurodytas el. pašto adresas neregistruotas',
      emailIdentityLookup: 'Nepavyko patvirtinti el. pašto adreso',
      emailLocked: 'Nurodytas el. pašto adresas laikinai užblokuotas Mastercard sistemoje',
      paywayRequired: 'Norėdami sumokėti, pasirinkite banką',
      creditCardRequired: 'Užpildykite visus laukus',
      phoneRequired: 'Įveskite galiojantį telefono numerį',
      regulationRequired: 'Sutikite su taisyklėmis ir sąlygomis',
      requiredConsent: 'Reikalingas sutikimas',
      codeNotValid: 'Pateiktas kodas negalioja',
      codeAccountLocked: 'Paskyra laikinai užblokuota',
      unknownError: 'Įvyko netikėta klaida'
    },
    validatorsAria: {
      required: 'Dėmesio. Formos laukas neužpildytas. Privalomas laukas',
      pattern: 'Dėmesio. Lauke yra neteisinga reikšmė.',
      blikCode: 'Dėmesio. Įveskite 6 skaitmenų BLIK kodą',
      emailRequired: 'Dėmesio. El. pašto laukas neužpildytas. Nurodykite teisingą el. pašto adresą',
      emailNotValid: 'Dėmesio. Jūsų el. pašto adresu yra klaida. Nurodykite teisingą el. pašto adresą',
      emailNotRecognized: 'Dėmesio. Nurodytas el. pašto adresas neregistruotas.',
      emailIdentityLookup: 'Dėmesio. Nepavyko patvirtinti pateikto el. pašto adreso.',
      emailLocked: 'Dėmesio. Nurodytas el. pašto adresas laikinai užblokuotas Mastercard sistemoje.',
      paywayRequired: 'Dėmesio. Mokėjimas nepasirinktas. Pasirinkite mokėjimo būdą',
      creditCardRequired: 'Dėmesio. Užpildykite visus laukus nurodydami kredito kortelės duomenis',
      phoneRequired: 'Dėmesio. Telefono numerio lauke yra klaida. Įveskite galiojantį telefono numerį.',
      codeNotValid: 'Dėmesio. Pateiktas kodas negalioja.',
      codeAccountLocked: 'Dėmesio. Paskyra laikinai užblokuota.',
      unknownError: 'Dėmesio. Įvyko netikėta klaida.'
    },
    success: {
      copy: 'Nukopijuota!',
      codeSent: 'Kodas išsiųstas!'
    },
    errors: {
      getPdf: 'Nepavyko atsisiųsti PDF!',
      copy: 'Nepavyko nukopijuoti!',
      thankYouUpdate: 'Nepavyko išsaugoti el. pašto adreso!',
      groupInactive: 'Šiuo metu neįmanoma atlikti pervedimo naudojant grupę {groupName}. Pasirinkite kitą mokėjimo būdą.',
      paywayInactive: 'Šiuo metu dėl techninių priežasčių neįmanoma atlikti pavedimo iš pasirinkto banko. Pasirinkite kitą banką arba mokėjimo metodą.',
      googlePayInactive: 'Deja, Google Pay mokėjimas jūsų įrenginyje nepasiekiamas.',
      applePayInactive: 'Apple Pay galima naudoti žmonėms, naudojantiems Safari ir iOS įrenginius.',
      codeNotSent: 'Nepavyko pakartotinai išsiųsti kodo!',
      codeCounterExceeded: 'Viršytas leistinas bandymų skaičius. Įveskite kortelės duomenis rankiniu būdu arba naudokite kitą mokėjimo būdą.'
    }
  },
  modal: {
    closeButton: 'Uždaryti',
    confirmButton: 'suprantu'
  },
  configuration: {
    paywayGroups: {
      auto: {
        label: 'Pasikartojantis mokėjimas',
        description: 'Įveskite kortelės, kurią naudosite mokėdami, duomenis. Automatiniai mokėjimai bus paimti iš jūsų kortelės vėliau.',
        labelInitWithRefund: 'Patvirtinimo mokėjimas',
        labelInitWithRefundOrange: 'Pridėti mokėjimo kortelę',
        labelInitWithPayment: 'Mokėjimas kortele',
        descriptionInitWithRefund: 'Įveskite išsamią kortelės informaciją, kurią norite patvirtinti būsimiems mokėjimams. Kitame žingsnyje nuo nurodytos kortelės nuskaičiuosime 1 PLN, kad patikrintume duomenų teisingumą. Po patikrinimo grąžinsime sumą.',
        descriptionInitWithPayment: 'Įveskite kortelės, kurią naudosite atlikdami operaciją, duomenis ir tuo pačiu patvirtinkite ją būsimiems mokėjimams.'
      },
      blik: {
        label: 'PAŽIŪRĖKITE',
        description: 'Mokėkite akimirksniu įvedę BLIK kodą, be prisijungimo ar registracijos'
      },
      blikAuto: {
        label: 'BLIK periodiniai mokėjimai',
        description: 'Šiam prekybininkui galite įjungti pasikartojančius BLIK mokėjimus, o vėlesni mokėjimai bus automatiškai nurašyti iš jūsų sąskaitos.'
      },
      card: {
        label: 'Mokėjimas kortele',
        description: 'Mokėkite savo banko kortele'
      },
      pbl: {
        label: 'Perdavimas internetu',
        description: 'Pasirinkite banką, iš kurio norite atlikti mokėjimą',
        descriptionVerify: 'Tapatybės patvirtinimas internetu',
        descriptionServiceVerify: 'Pasirinkite banką, kuris leis jums patvirtinti paslaugą internetu'
      },
      visaMobile: {
        label: 'VisaMobile',
        description: 'Visa Mobile mokėjimo'
      },
      wallet: {
        label: 'Google&nbsp;Pay | Apple&nbsp;Pay',
        description: 'Mokėkite neprisijungę prie internetinės bankininkystės'
      },
      installments: {
        label: 'Mokėjimas išsimokėtinai',
        description: 'Apmokėkite už pirkinius patogiomis dalimis.'
      },
      alior: {
        descriptionInfo1: 'Apmokėkite už pirkinius patogiomis dalimis.',
        descriptionInfo2: '(patikrinkite informaciją)',
        aliorModal: {
          text1: 'Atsižvelgiant į svetainės, kurioje perkate, nustatymus, išsimokėtinai galite įsigyti šių variantų:',
          text2: '<ul><li>10 įmokų 0 %</li><li>20 įmokų 0 %</li><li>nuo 3 iki 48 įmokų su 1 % mėnesio mokesčiu (pagal tipinį konkrečios operacijos pavyzdį)</li></ul>'
        }
      },
      otp: {
        label: 'Mokėkite vėliau',
        description: 'Pirkite dabar ir mokėkite vėliau',
        descriptionInfo1Mwf: 'Sąskaitą apmokėkite vėliau – vieną kartą iki 45 dienų arba keliomis lygiomis dalimis',
        descriptionInfo1Ecommerce: 'Mokėti vėliau – vieną kartą iki 45 dienų arba keliomis lygiomis dalimis',
        descriptionInfo2Mwf: 'Informacija apie kredito tarpininką ir kainą',
        descriptionInfo2Ecommerce: 'Informacija apie išlaidas',
        labelPayka: 'Jis yra',
        descriptionPayka: 'Sąskaitą apmokėkite vėliau – vieną kartą iki 30 dienų arba 4 lygiomis dalimis <a href="" id="paykaShowInModal">Informacija apie kredito tarpininką ir kainą</a>',
        paykaModalMwf: {
          header1: 'Paskolos brokerio pranešimas',
          text1: 'Autopay S.A., kurios būstinė yra Sopote, veikia kaip paskolų brokeris Paytree S.A., kurios būstinė yra Gdanske, Lenkija (skolintojas), įgaliota pateikti paskolos pasiūlymą klientams ir nukreipti į skolintojo svetainę, įskaitant paskolos paraišką. Jei reikia išsamios informacijos apie pasiūlymą, apsilankykite adresu <a href="https://payka.pl/rachunki-domowe" target="_blank">Namų ūkio sąskaitos – Payka</a>.',
          header2: 'Išsami informacija apie kainą',
          text2: 'Mokėti vėliau – vieną kartą iki 45 dienų arba keliomis lygiomis dalimis. Išlaidų duomenys reprezentatyviam pavyzdžiui: Grąžinimas per 45 dienas APR 0%; Įmokos grąžinimas APR 74,11%. Išsami pasiūlymo informacija: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        },
        paykaModalEcommerce: {
          header2: 'Išsami informacija apie kainą',
          text2: 'Mokėti vėliau – vieną kartą iki 45 dienų arba keliomis lygiomis dalimis. Išlaidų duomenys reprezentatyviam pavyzdžiui: Grąžinimas per 45 dienas APR 0%; Įmokos grąžinimas APR 74,11%. Išsami pasiūlymo informacija: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        }
      },
      blikPayLater: {
        label: 'BLIK mokėk vėliau',
        description: ''
      },
      companyPayments: {
        label: 'Verslo mokėjimas',
        description: 'Atidėkite verslo pirkinių mokėjimo datą 30 dienų'
      },
      transfer: {
        label: 'Perdavimo detalės',
        description: 'Užsisakykite pervedimą naudodami pateiktą informaciją'
      },
      other: {
        label: 'Kita',
        description: ''
      }
    },
    mobileEvents: {
      statusDescription: {
        bankDisabled: 'Atsiprašau. Šiuo metu negalime apdoroti jūsų pervedimo. Pasirinktas bankas šiuo metu nepasiekiamas.',
        blockMultipleTransactions: 'Atsiprašau. Sandoris jau egzistuoja ir laukia apmokėjimo.',
        blockPaidTransactions: 'Atsiprašau. Už sandorį jau buvo sumokėta. Negalite dar kartą atlikti mokėjimo.',
        canceledTransactions: 'The transaction you are trying to pay for has been cancelled and is not available. Prašom pradėti naują operaciją.',
        declined: 'Leidimo atsisakymas.',
        generalError: 'Įvyko laikina ryšio problema. Šiuo metu negalime apdoroti jūsų pervedimo. Grįžkite vėliau.',
        insufficientStartAmount: 'Atsiprašau. Viršytas pervedimo sumos limitas.',
        internalServerError: 'Oi, operacija nepavyko:(. Stengiamės išspręsti problemą. Vėliau bandykite dar kartą.',
        nonAccountedLimitExceeded: 'Mokėjimas negali būti atliktas, nes pardavėjas pasiekė mėnesio pardavimo limitą.',
        outdatedError: 'Laikas atlikti mokėjimą praėjo..',
        paid: 'Sandoris sėkmingai užbaigtas.',
        paywayLoaded: 'Greito perdavimo puslapis buvo įkeltas',
        paywaylistLoaded: 'Mokėjimo būdo pasirinkimo puslapis įkeltas'
      }
    }
  },
  maintenance: {
    text1: 'Vyksta Naujųjų metų automatinio mokėjimo šliuzo valymas, todėl šiuo metu negalima užsisakyti mokėjimų. Atsiprašome už nepatogumus.',
    text2: 'Vartai vėl pradės veikti jau sausio 16 d., 10 val.',
    text3: 'Dėkojame už supratingumą.'
  },
  requiredParams: {
    accountHolderName: {
      label: 'Įveskite paskyros savininko informaciją',
      flowLabel: 'Paskyros savininkas',
      placeholder: 'Įveskite paskyros savininko informaciją'
    },
    nip: {
      label: 'Įveskite savo mokesčių mokėtojo numerį',
      flowLabel: 'NIP',
      placeholder: 'Įveskite savo mokesčių mokėtojo numerį'
    },
    customerEmail: {
      label: 'Įveskite savo el. pašto adresą',
      flowLabel: 'El. pašto adresas',
      placeholder: 'Įveskite savo el. pašto adresą'
    },
    senderIban: {
      label: 'Užpildykite savo IBAN',
      flowLabel: 'IBAN',
      placeholder: 'Užpildykite savo IBAN'
    },
    shippingBuildingNumber: {
      label: 'Įveskite pastato numerį',
      flowLabel: 'Pastatas Nr.',
      placeholder: 'Pastatas Nr.'
    },
    shippingPostalCode: {
      label: 'Įveskite pašto kodą',
      flowLabel: 'Pašto kodas',
      placeholder: 'Pašto kodas'
    },
    shippingStreetName: {
      label: 'Įveskite gatvę',
      flowLabel: 'Gatvė',
      placeholder: 'Gatvė'
    },
    shippingLastName: {
      label: 'Įveskite pavardę',
      flowLabel: 'Pavardė',
      placeholder: 'Pavardė'
    },
    shippingCountryCode: {
      label: 'Įveskite šalį',
      flowLabel: 'Šalis',
      placeholder: 'pasirinkite šalį'
    },
    shippingRegion: {
      label: 'Įveskite regioną',
      flowLabel: 'Regionas',
      placeholder: 'Regionas'
    },
    shippingFlatNumber: {
      label: 'Įveskite buto numerį',
      flowLabel: 'Apt. ne.',
      placeholder: 'Apt. ne.'
    },
    shippingFirstName: {
      label: 'Įveskite vardą',
      flowLabel: 'Vardas',
      placeholder: 'Vardas'
    },
    shippingCity: {
      label: 'Įveskite miestą',
      flowLabel: 'Miestas',
      placeholder: 'Miestas'
    }
  },
  survey: {
    skipSurvey: 'Praleisti apklausą',
    skipSurveyLabel: 'Praleisti apklausos skyrių',
    sectionLabel: 'Apklausa'
  }
}
